import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from "./hooks/useAuth";
import ProtectedRoute from "./components/auth/ProtectedRoute";
import AdminRoute from "./components/auth/AdminRoute";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import Screenshots from "./components/Screenshots";
import Download from "./components/Download";
import Footer from "./components/Footer";
import MentionsLegales from "./pages/mentions-legales";
import CGV from "./pages/CGV";
import Confidentialite from "./pages/Confidentialite";
import FAQ from "./pages/FAQ";
import NotFound from "./pages/NotFound";
import LoginPage from "./pages/LoginPage";
import ResetPassword from "./pages/ResetPassword";
import EmailVerification from "./pages/EmailVerification";
import DashboardPage from "./pages/DashboardPage";
import ProfilePage from "./pages/ProfilePage";
import DeactivatedAccount from "./pages/DeactivatedAccount";
import AdminPage from "./pages/AdminPage";

// Chargée à la demande : importer PurchasePage charge Stripe.js (et ses traceurs anti-fraude),
// qui ne doivent être présents que sur la page d'achat.
const PurchasePage = lazy(() => import("./pages/PurchasePage"));

export default function AppRouter() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-gray-950 dark:bg-gray-950" style={{ colorScheme: 'dark' }}>
          <Toaster position="top-right" />
          <Header />
          <main>
            <Routes>
              <Route path="/" element={
                <>
                  <Hero />
                  <Features />
                  <Pricing />
                  <Screenshots />
                  <Download />
                </>
              } />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/auth/verify" element={<EmailVerification />} />
              <Route path="/deactivated-account" element={<DeactivatedAccount />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
              <Route path="/purchase" element={
                <ProtectedRoute>
                  <Suspense
                    fallback={
                      <div className="min-h-screen flex items-center justify-center">
                        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-purple-600"></div>
                      </div>
                    }
                  >
                    <PurchasePage />
                  </Suspense>
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminPage />
                </AdminRoute>
              } />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/cgv" element={<CGV />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}
